export enum SessionTextChatMessageOwner {
    Own = 'own',
    Foreign = 'foreign',
    System = 'system',
    Chatbot = 'chatbot'
}